import { styled } from '@mui/material';

export const CardStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '100%',
}));

export const Location = styled('h2')(() => ({
  fontWeight: 300,
  textAlign: 'center',
}));
